module.exports = __webpack_public_path__ + "img/14.be05cb09.jpg";